import {Link} from 'react-router-dom';
import {useI18n} from '../../../../common/providers/I18nProvider';

interface Props {
	title: string;
	route: string;
}

export default function RightAlignedLink({title, route}: Props) {
	const {i18n} = useI18n();

	return (
		<div className='mb-4 sm:mb-5 lg:mb-9 flex justify-end'>
			<Link className='text-primary text-sm sm:text-2xs lg:text-sm font-medium text-center' to={route}>
				{i18n(title)}
			</Link>
		</div>
	);
}
